import {
  type EvaluationRecipientResponse,
  type EvaluationRecipientRequest as EvaluationRecipientRequestType,
} from "../api";
import { Utility } from "./utility";

export interface EvaluationRecipient extends EvaluationRecipientResponse {}
export interface EvaluationRecipientRequest extends EvaluationRecipientRequestType {}

export class EvaluationRecipientRequest extends Utility<EvaluationRecipientRequest> {
  constructor(init?: Partial<EvaluationRecipientRequest>) {
    super();
    Object.assign(this, init);
  }
}

export class EvaluationRecipient extends Utility<EvaluationRecipient> {
  constructor(init?: Partial<EvaluationRecipientResponse>) {
    super();
    Object.assign(this, init);
  }
}
